export default __webpack_public_path__ + "static/media/EM1720.34I-40959_-24341_0.0bd7999b.jpg";